import { createSlice } from "@reduxjs/toolkit";

export const TicketSlice = createSlice({
  name: "ticket" as string,
  initialState: {
    reCallTicketDetails: null as null | any,
    getDynamicColumnValue: undefined as any,
  },

  reducers: {
    handleReCallTicketDetails: (state, action) => {
      state.reCallTicketDetails = action.payload;
    },
    handleDynamicColumnValue: (state, action) => {
      state.getDynamicColumnValue = action.payload;
    },
  },
});

export const { handleReCallTicketDetails, handleDynamicColumnValue } =
  TicketSlice.actions;
export default TicketSlice.reducer;
